import { CardAlertRow, type CardAlertRowSeverity } from '@nrg/design-system';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import type { Notification, NotificationSeverity } from '@/modules/topbar/data/types';
import { formatRelativeTime } from '@/modules/topbar/utils/format';
import styles from './NotificationButton.module.css';

const SEVERITY_MAP: Record<NotificationSeverity, CardAlertRowSeverity> = {
  critical: 'critical',
  warning: 'warning',
  info: 'info',
};

interface NotificationListProps {
  items: Notification[];
  onSelect: () => void;
}

export function NotificationList({ items, onSelect }: NotificationListProps) {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();

  if (items.length === 0) {
    return <p className={styles.empty}>{t('topbar.notifications.empty')}</p>;
  }

  return (
    <div className={styles.list}>
      {items.map((item) => (
        <CardAlertRow
          key={item.id}
          severity={SEVERITY_MAP[item.severity]}
          title={t(item.titleKey)}
          description={item.descriptionKey ? t(item.descriptionKey) : undefined}
          time={formatRelativeTime(item.occurredAt, i18n.language)}
          size="sm"
          onClick={() => {
            onSelect();
            navigate(item.href);
          }}
        />
      ))}
    </div>
  );
}
